/**
 * "+914428123456" -> "+91 44 2812 3456", "+919876543210" -> "+91 98765 43210".
 *
 * Only for reading: the `tel:` link keeps the number exactly as the salon wrote it. Indian numbers
 * are grouped the way they are said (a mobile starts 6 to 9); anything else is shown as written,
 * because a wrong grouping is worse than none.
 */
export function formatPhone(phone: string): string {
  const compact = phone.replace(/[\s-]/g, "");
  const india = /^\+91(\d{10})$/.exec(compact)?.[1];
  if (!india) return phone;
  return /^[6-9]/.test(india)
    ? `+91 ${india.slice(0, 5)} ${india.slice(5)}`
    : `+91 ${india.slice(0, 2)} ${india.slice(2, 6)} ${india.slice(6)}`;
}
